import React from 'react';
import { FileText, DollarSign, Users, TrendingUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const DepositReportStats = ({
  totalRecords,
  totalCollected,
  totalRefunds,
  netAmount,
  activeAgents,
  averageDeposit
}) => {
  const { t } = useTranslation();

  const stats = [
    {
      title: t('totalRecords'),
      value: totalRecords.toLocaleString(),
      icon: <FileText size={24} />,
      color: 'blue'
    },
    {
      title: t('totalCollected'),
      value: `${totalCollected.toLocaleString()} ${t('EGP')}`,
      icon: <DollarSign size={24} />,
      color: 'green'
    },
    {
      title: t('totalRefunds'),
      value: `${totalRefunds.toLocaleString()} ${t('EGP')}`,
      icon: <DollarSign size={24} />,
      color: 'red'
    },
    {
      title: t('netAmount'),
      value: `${netAmount.toLocaleString()} ${t('EGP')}`,
      icon: <TrendingUp size={24} />,
      color: netAmount >= 0 ? 'green' : 'red'
    },
  ];

  const activeAgentStat = {
    title: t('activeAgents'),
    value: activeAgents.toString(),
    icon: <Users size={16} />,
    color: 'purple'
  };

  const getColorClasses = (color) => {
    const colorMap = {
      blue: 'bg-blue-50 text-blue-600',
      green: 'bg-green-50 text-green-600',
      red: 'bg-red-50 text-red-600',
      purple: 'text-purple-600',
      orange: 'bg-orange-50 text-orange-600'
    };
    return colorMap[color] || colorMap.blue;
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {stats.map((stat, index) => (
        <div key={index} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-100 hover:shadow-md transition-shadow duration-300">
          <div className="flex items-start justify-between">
            <div>
              <p className="text-slate-500 text-sm font-medium mb-2">{stat.title}</p>
              {index === 0 && <div className='flex  items-center'>
                <p className="text-2xl font-bold text-slate-900 me-3">{stat.value}</p>
                <div className='flex items-center'>
                  <div className={`${getColorClasses(activeAgentStat.color)}`}>
                    {activeAgentStat.icon}
                  </div>
                  <p className="text-slate-500 text-sm font-medium ms-2">{activeAgentStat.value}</p>
                </div>
              </div>}
              {index !== 0 && <p className="text-2xl font-bold text-slate-900 mb-1">{stat.value}</p>}
            </div>
            <div className={`p-3 rounded-xl ${getColorClasses(stat.color)}`}>
              {stat.icon}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DepositReportStats;